import React from "react";
import DDados from "../habitese.ddados";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import HabiteseForm from "../components/habitese.form";
import habiteseActions from '../store/habitese.actions';

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }

  componentDidMount() {
    const values = this.props.routerManager.params;

    if (Object.keys(values).length) {
      if (values.validarDireto) {
        let dto = {
          NumeroProjeto: values.numeroProjeto,
          AnoProjeto: values.anoProjeto,
          NumeroHabitese: values.numeroHabitese,
          DataEmissaoHabitese: this.ajustarData(values.emissaoHabitese)
        };

        this.props.habiteseActions.setHabitese(dto);
        this.props.habiteseActions.getValidarHabitese();
      }
    }
  }

  ajustarData(d) {
    // Ás vezes a conversão de string para data do javascript aplica fuso-horário,
    // gerando um resultado errado (por exemplo: '2020-06-01' transforma-se em 2020-05-31)
    // passando os componentes da data individualmente parece evitar conversão
    if (d && d.length == 10)
    {
      const ano = parseInt(d.substring(0, 4));
      const mes = parseInt(d.substring(5, 7)) - 1; // mês começa em zero
      const dia = parseInt(d.substring(8, 10));

      return new Date(ano, mes, dia);
    }

    return d;
  }

  onValidate() {
    this.props.habiteseActions.getValidarHabitese();
  }

  render() {
    return <HabiteseForm title="Validação de Habite-se" onValidate={this.onValidate} onPrint={false} />;
  }
}

export default connect({
  actions: {
    habiteseActions,
  }
})(Container);
